export default function InvoiceSkeleton() {
  return (
    <main className="mx-auto w-full max-w-7xl p-4 md:p-8">
      <div className="mb-4 flex items-center justify-between">
        <div className="h-7 w-40 animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="h-9 w-32 animate-pulse rounded-lg bg-[#F0E0C7]/60" />
      </div>
      <div className="h-[85vh] w-full animate-pulse rounded border bg-[#F0E0C7]/40" />
    </main>
  );
}
